module.exports = __webpack_public_path__ + "assets/img/logo-login.a43bbe83.png";